import { Receipt, ReceiptText, Settings2 } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const invoicing = defineDashboardModule({
  id: "invoicing",
  requires: ["clients"],
  nav: [
    { group: "Business", title: "Invoices", to: "/invoices", icon: Receipt },
    {
      group: "Business",
      title: "Receipts",
      to: "/receipts",
      icon: ReceiptText,
    },
    {
      group: "System",
      title: "Billing",
      to: "/settings/billing",
      icon: Settings2,
    },
  ],
  routes: [
    {
      path: "/invoices",
      component: lazyPage(
        () => import("./routes/invoice-list"),
        "InvoiceListPage"
      ),
    },
    {
      path: "/invoices/new",
      component: lazyPage(
        () => import("./routes/invoice-editor"),
        "InvoiceEditorPage"
      ),
    },
    {
      path: "/invoices/:id",
      component: lazyPage(
        () => import("./routes/invoice-editor"),
        "InvoiceEditorPage"
      ),
    },
    {
      path: "/receipts",
      component: lazyPage(
        () => import("./routes/receipt-list"),
        "ReceiptListPage"
      ),
    },
    {
      path: "/receipts/new",
      component: lazyPage(
        () => import("./routes/receipt-new"),
        "ReceiptNewPage"
      ),
    },
    {
      path: "/receipts/:id",
      component: lazyPage(
        () => import("./routes/receipt-view"),
        "ReceiptViewPage"
      ),
    },
    {
      path: "/settings/billing",
      component: lazyPage(
        () => import("./routes/billing-settings"),
        "BillingSettingsPage"
      ),
    },
  ],
})
